"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmPropertyItemSingleSelectionRadio = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var models_1 = require("../../../../models");
var ConfirmPropertyItem_1 = require("../ConfirmPropertyItem");
var shared_1 = require("../shared");
var Subtext = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 4px;\n\n  label: SubtextWrapper;\n"], ["\n  margin-top: 4px;\n\n  label: SubtextWrapper;\n"])));
var ConfirmPropertyItemSingleSelectionRadio = function (_a) {
    var index = _a.index, label = _a.label, subtext = _a.subtext, className = _a.className, color = _a.color, propertyId = _a.propertyId;
    return (react_1.default.createElement(ConfirmPropertyItem_1.ConfirmPropertyItem, { propertyId: propertyId, propertyType: models_1.PROPERTY_TYPE.singleSelection, inputFormatType: models_1.SINGLE_SELECTION_PROPERTY_INPUT_TYPE.radio, className: className, color: color },
        react_1.default.createElement("div", null, (0, shared_1.buildLabelWithIndexIfNeeded)({ index: index, label: label })),
        subtext && react_1.default.createElement(Subtext, null, subtext)));
};
exports.ConfirmPropertyItemSingleSelectionRadio = ConfirmPropertyItemSingleSelectionRadio;
var templateObject_1;
